import React, { useContext, useEffect, useState } from "react";
import CustomFolderList from "../../Components/CustomFolderList";
import GridView from "../../Components/GridView";
import { useHistory } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ApiCallGateway } from "../../Network/apiCallGateway";
import { DataContext } from "../../context/DataContext";
import AddFolderModal from "../../Components/Modal/AddFolderModal";
import {
  addFolderschema,
  sharefolderSchemaObj,
} from "../../Validation/FolderValidation";
import { useFormik } from "formik";
import ShareModal from "../../Components/Modal/ShareModal";
import NoData from "../../Components/NoData";
import Pagination from "../../Components/Pagination/Pagination";
import ConfirmModal from "../../Components/Modal/ConfirmModal";

function SharedFolders(props) {
  const history = useHistory();
  const {
    setFolderDetails,
    setIsShared,
    setLoader,
    getFolderAccessList,
    adminViewUser,
    setBrudCrumb,
    setSidebarSelected,
  } = useContext(DataContext);

  const [addFolderModal, setAddFolderModal] = useState(false);
  const [fDetails, setFdetails] = useState({});
  const [folderEdit, setFolderEdit] = useState(true);
  const [tab, setTab] = useState("fol");
  const [viewType, setViewType] = useState("list");
  const [shareFolderPage, setShareFolderPage] = useState(1);
  const [shareEnvPage, setshareEnvPage] = useState(1);
  const [folderId, setFolderId] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const confirmtoggle = () => setConfirmModal(!confirmModal);
  const addFoldertoggle = () => setAddFolderModal(!addFolderModal);
  const sharetoggle = () => setShareModal(!shareModal);
  const {
    isLoading,
    error,
    data: folderList,
    refetch,
  } = useQuery({
    queryKey: ["shareFolderList"],
    queryFn: async () => {
      const res = await ApiCallGateway.folder.getAllShareFolders(
        shareFolderPage,
        adminViewUser?._id || null
      );
      if (res?.status === 200) {
        return res?.data;
      } else {
        return [];
      }
    },
  });

  useEffect(() => {
    refetch();
    setIsShared(true);
    setSidebarSelected("shared");
  }, [shareFolderPage, adminViewUser]);

  // console.log(folderList);

  const folderFormik = useFormik({
    initialValues: {
      name: folderEdit ? fDetails?.name : "",
      description: folderEdit ? fDetails?.description : "",
      color: folderEdit ? fDetails?.color : "",
    },
    validationSchema: addFolderschema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      console.log(values, fDetails);
      let res;
      if (folderEdit) {
        res = await ApiCallGateway.folder.updateFolderEnv(
          values,
          fDetails?.passwordFolderId
        );
      }
      addFoldertoggle();
      refetch();
      console.log(res);
    },
  });
  const shareFolderFormik = useFormik({
    initialValues: {
      folderId: "",
      shareWith: [],
      note: "",
    },
    validationSchema: sharefolderSchemaObj,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      let data = [];
      // console.log({ ...values, shareWith: selectedUsers });
      for (const element of selectedUsers) {
        let a = {
          passwordFolderId: values.folderId,
          shareWith: element?._id,
          sharedEmail: element?.email,
          sharedName: element?.name,
          expiryDate: null,
          note: values.note,
          isNew: !element?._id,
        };
        data.push(a);
      }
      // console.log(data, "kkk");
      const res = await ApiCallGateway.folder.shareFolderEnv(
        data,
        false
      );
      // console.log(res);
      sharetoggle();
      resetForm();
    },
  });

  const deleteFolder = async (id) => {
    setLoader(true);
    const res = await ApiCallGateway.folder.deleteFolderEnv(id);
    // console.log(res);
    if (res?.status === 200) {
      confirmtoggle();
      refetch();
      setLoader(false);
    }
    setLoader(false);
  };

  const handleSelectUsers = (user) => {
    if (!selectedUsers.includes(user)) {
      setSelectedUsers((oldValue) => [...oldValue, user]);
    }
  };

  const removeSelectUsers = (user) => {
    if (selectedUsers.includes(user)) {
      setSelectedUsers(selectedUsers.filter((u) => u !== user));
    }
  };

  return (
    <div>
      {props?.viewType === "list" ? (
        <CustomFolderList
          env_subfolder={false}
          onItem={(fdetails) => {
            history.push(
              `/env_subfolder/${fdetails?.passwordFolderId}`
            );
            setFolderDetails(fdetails);
          }}
          detailstoggle={(details) => {
            history.push(
              `/env_subfolder/${details?.passwordFolderId}`
            );
            setFolderDetails(details);
          }}
          confirmtoggle={(item) => {
            confirmtoggle();
            setFolderId(item?.passwordFolderId);
          }}
          sharetoggle={(item) => {
            sharetoggle();
            setFolderId(item?.passwordFolderId);
            shareFolderFormik.setValues(
              "passwordFolderId",
              item?.passwordFolderId
            );
            getFolderAccessList(item?.passwordFolderId);
          }}
          edittoggle={(details) => {
            // console.log(details);
            setFdetails(details);
            setFolderEdit(true);
            addFoldertoggle();
          }}
          data={folderList?.data}
        />
      ) : null}
      {props?.viewType === "grid" ? (
        <GridView
          env_subfolder={false}
          onItem={(e) => {
            history.push(`/env_subfolder/${e?.passwordFolderId}`);
            setFolderDetails(e);
          }}
          data={folderList?.data}
        />
      ) : null}

      <AddFolderModal
        title={" Edit Folder/Project"}
        addFolderModal={addFolderModal}
        addFoldertoggle={addFoldertoggle}
        isEdit={folderEdit}
        formik={folderFormik}
        // handleSelectUsers={(id) => handleSelectUsers(id)}
        // removeSelectUsers={(id) => removeSelectUsers(id)}
        // selectedUsers={selectedUsers}
      />
      <ShareModal
        isFolder={true}
        md={true}
        shareModal={shareModal}
        shareModaltoggle={sharetoggle}
        formik={shareFolderFormik}
        handleSelectUsers={(id) => handleSelectUsers(id)}
        removeSelectUsers={(id) => removeSelectUsers(id)}
        selectedUsers={selectedUsers}
      />
      {folderList?.data?.length < 1 ? <NoData /> : null}
      <Pagination
        totalPost={folderList?.total}
        postsPerPage={12}
        setCurrentPage={(e) => setShareFolderPage(e)}
        currentPage={shareFolderPage}
      />
      <ConfirmModal
        confirmModal={confirmModal}
        confirmModaltoggle={confirmtoggle}
        passwordId={folderId}
        onProceed={(id) => deleteFolder(id)}
      />
    </div>
  );
}

export default SharedFolders;
